import { Toast } from "@/components/atoms/toast";
import EventInformationForm from "@/components/templates/Checkout/forms/event-info-form";
import { __ } from "@/lib/i18n/functions";

type EventInformationProps = {
  resolution: Resolution;
};

const EventInformation = ({ resolution }: EventInformationProps) => {
  return (
    <article className="flex-3/5">
      <section className="space-y-5">
        <h2 className="font-cabinet-grotesk text-base font-medium sm:text-xl md:text-2xl lg:text-3xl">
          {__("Some information about your event", resolution.locale)}
        </h2>
        <Toast
          id="basket-b"
          type="info"
          title={__(
            "This information is very useful to us in order to guarantee you the best experience during the preparation and delivery of your order.",
            resolution.locale
          )}
          className="max-w-none font-medium shadow-none"
        />
        <hr className="border-primary-light/30" />
        <EventInformationForm locale={resolution.locale} />
      </section>
    </article>
  );
};

export default EventInformation;
